import { MutableRefObject, useRef } from "react";

export function useFocus<T>(): [MutableRefObject<T>, Function] {
  const htmlRef = useRef(null);
  const setFocus: Function = () => {
    htmlRef.current?.focus();
  };
  return [htmlRef, setFocus];
}
